export const LEVEL_OPTIONS = [
	{
		id: "state",
		title: "State level",
		description: "Get access to State level curriculum for the exams",
	},
	{
		id: "national",
		title: "National level",
		description: "Get access to National level curriculum for the exams",
	},
	{
		id: "advanced",
		title: "Advanced level",
		description: "Get access to Advanced level curriculum for the exams",
	},
];

export const PROFILE_SAVE_DEBOUNCE_MS = 750;
